import { useEffect, useState } from 'react';
import { IonButton, IonSpinner } from '@ionic/react';
import QRCode from 'qrcode';

// T-267: pannello rapido per condividere l'app col cliente/staff. Due link
// STABILI (trackeat.eu/apk → ultimo APK, trackeat.eu/app → PWA) con copia +
// QR generato offline. Visibile solo a consulente/owner (gating nel parent).

const APK_URL = 'https://trackeat.eu/apk';
const PWA_URL = 'https://trackeat.eu/app';

interface ShareAppCardProps {
  onToast: (msg: string) => void;
}

export function ShareAppCard({ onToast }: ShareAppCardProps): JSX.Element {
  const [apkQr, setApkQr] = useState<string | null>(null);
  const [pwaQr, setPwaQr] = useState<string | null>(null);
  const [openQr, setOpenQr] = useState<null | 'apk' | 'pwa'>(null);

  useEffect(() => {
    let alive = true;
    const opts = { width: 220, margin: 1 } as const;
    void QRCode.toDataURL(APK_URL, opts).then((d: string) => { if (alive) setApkQr(d); }).catch(() => undefined);
    void QRCode.toDataURL(PWA_URL, opts).then((d: string) => { if (alive) setPwaQr(d); }).catch(() => undefined);
    return () => { alive = false; };
  }, []);

  async function copy(url: string, label: string): Promise<void> {
    try { await navigator.clipboard.writeText(url); onToast(`${label} copiato`); }
    catch { onToast('Copia non riuscita'); }
  }

  function row(kind: 'apk' | 'pwa', emoji: string, title: string, desc: string, url: string, qr: string | null): JSX.Element {
    return (
      <div style={{ borderTop: '1px solid #f1f5f9', paddingTop: 10, marginTop: 10 }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: '#0f172a' }}>{emoji} {title}</div>
        <div style={{ fontSize: 12, color: '#64748b', marginBottom: 8 }}>{desc}</div>
        <div style={{ display: 'flex', gap: 6 }}>
          <IonButton size="small" fill="outline" style={{ '--border-radius': '8px', flex: 1 } as React.CSSProperties}
            onClick={() => { void copy(url, title); }}>Copia link</IonButton>
          <IonButton size="small" fill="solid" style={{ '--border-radius': '8px', flex: 1 } as React.CSSProperties}
            onClick={() => setOpenQr(openQr === kind ? null : kind)}>{openQr === kind ? 'Nascondi QR' : 'Mostra QR'}</IonButton>
        </div>
        {openQr === kind && (
          <div style={{ textAlign: 'center', marginTop: 10 }}>
            {qr ? <img src={qr} alt={`QR ${title}`} style={{ width: 200, height: 200 }} />
                : <IonSpinner name="dots" />}
            <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 4, wordBreak: 'break-all' }}>{url}</div>
          </div>
        )}
      </div>
    );
  }

  return (
    <div style={{
      background: '#fff', borderRadius: 16, padding: '14px 16px', marginBottom: 12,
      boxShadow: '0 1px 2px rgba(15,23,42,.06), 0 2px 6px rgba(15,23,42,.05)', border: '1px dashed #c7d2fe',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
        <div style={{ fontSize: 11, fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
          Condividi l'app
        </div>
        <span style={{ fontSize: 10, fontWeight: 700, color: '#1d4ed8', background: '#dbeafe',
          padding: '2px 8px', borderRadius: 999, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Consulente</span>
      </div>
      <div style={{ fontSize: 12, color: '#64748b', lineHeight: 1.4 }}>
        Link e QR pronti per far installare TrackEAT al cliente o allo staff.
      </div>
      {row('apk', '📱', 'APK Android', 'Scarica e installa su Android (link sempre aggiornato).', APK_URL, apkQr)}
      {row('pwa', '🌐', 'TrackEAT online (PWA)', 'Apri nel browser, anche da iPhone o computer.', PWA_URL, pwaQr)}
    </div>
  );
}
